module.exports = __webpack_public_path__ + "static/img/label-ANR-bleu-CMJN.51ff0c5.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/label-ANR-bleu-CMJN.png
// module id = 3/eV
// module chunks = 1